import styled from 'styled-components';

export const EventModalWrap = styled.div`
  z-index: 110;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3); // 배경을 반투명 검은색으로 덮어서 클릭을 방지합니다.
  display: flex;
  justify-content: center;
  align-items: center;

  .modalContent {
    background: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.txt400};
    border-radius: 8px;
    width: 100%;
    max-width: 480px; // 모달 최대 너비를 지정합니다.
    padding: 2rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
    position: relative;
  }

  .iconWrap {
    position: absolute;
    top: 10px;
    left: 10px;
    font-size: 2rem;
    color: ${(props) => props.theme.colors.blue};
  }

  .btnGroup {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1.4rem;
    gap: 1rem;

    button {
      width: auto;
      padding: 1rem;
      background: ${(props) => props.theme.colors.main};
      color: ${(props) => props.theme.colors.buttonText};
      font-size: 2rem;
      border: 1px solid ${(props) => props.theme.colors.gray400};
      border-radius: 4px;
      cursor: pointer;

      &:disabled {
        background: ${(props) => props.theme.colors.gray400};
        color: ${(props) => props.theme.colors.txt300};
        cursor: not-allowed;
      }
    }
  }

  .content {
    font-size: 1.4rem;
    line-height: 1.8;
    margin: 1rem;
    h1 {
      font-size: ${(props) => props.theme.fontSize.title16};
      color: ${(props) => props.theme.colors.txt500};
    }
  }

  .checkbox {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1.4rem;
    font-size: 1.4rem;
    cursor: pointer;
    input {
      height: 1.4rem;
      width: 1.4rem;
      margin-right: 0.5rem;
    }
  }
  .confirm {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 1.6rem;
    text-decoration: underline;
    button:hover {
      color: ${(props) => props.theme.colors.main};
    }
  }

  @media screen and (max-width: 478px) {
    .modalContent {
      width: 90%;
      padding: 1.5rem;
    }

    button {
      font-size: 1.2rem;
    }
  }
`;

export const ServiceTermsOverlay = styled.div`
  z-index: 110;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3); // 배경을 반투명 검은색으로 덮어서 클릭을 방지합니다.
  display: flex;
  justify-content: center;
  align-items: center;

  .serviceTermsContent {
    background: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.txt500};
    padding: 20px;
    border-radius: 10px;
    width: auto;
    max-width: 520px;
    text-align: center;
    font-size: 1.4rem;
    line-height: 1.8rem;

    h1 {
      margin-bottom: 20px;
    }

    p {
      margin-bottom: 20px;
    }

    button {
      background: ${(props) => props.theme.colors.main};
      color: white;
      padding: 10px 20px;
      border: none;
      border-radius: 5px;
      cursor: pointer;
    }
  }
`;
